
/* eslint-disable  */
import React, { useState, useMemo, } from 'react';
import Dayjs from 'dayjs';
import {
    Typography, Grid, IconButton, Menu, MenuItem
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@mui/x-data-grid';
import { useEmployee } from '~/employees';
import { getState } from '../../store';
import { MoreVert } from '@material-ui/icons';


const useStyles = makeStyles({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    tableWrapper: {
        width: '100%'
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    }
});

const EmployeeEvalList = props => {

    const classes = useStyles();
    const { match, history } = props;
    const { employee_id } = match.params;
    const { data: employee, isLoading } = useEmployee(employee_id);
    const isAdmin = getState().auth.role === 'admin';
    const [actions, setActions] = useState(null);
    const [rowSelected, setRowSelected] = useState();

    // console.log(props)

    // Evaluation Types
        const evalType = type => ({
            long: 'Long form',
            short: 'Short form'
        })[type];

 
    // Popover(Actions) settings.
      const openPopover = (event, row) => {
            setRowSelected(row)
            setActions(event.currentTarget);
        };
    const closePopover = () => {
            setActions(null);
        };
    const moreActions = Boolean(actions);
    

    //setup for evaluations column list
    const columns = useMemo(() => [

        {
            field: 'Type',
            renderHeader: () => <strong>Type</strong>,
            renderCell: ({ row }) => (
                <div>{evalType(row.type)}</div>
            ),
            flex: 1
        },
        {
            field: 'Date',
            renderHeader: () => <strong>Date</strong>,
            renderCell: ({ row }) => (
                <div>{Dayjs(row.date).format('MM/DD/YYYY')}</div>
            ),
            flex: 1
        },
        {
            field: 'Completed',
            renderHeader: () => <strong>Completed</strong>,
            renderCell: ({ row }) => (
                <div>{row.completed ? 'Yes' : 'No'}</div>
            ),
            flex: 1
        },
        //setup for actions column & adding a edit button to each row
        {
            field: 'id',
            align: 'right',
            headerAlign: 'right',
            renderHeader: () => <strong>Actions</strong>,
            renderCell: ({ row }) => (
                <div>
                    <IconButton onClick= { e => {
                        // console.log('jfjsif')
                        openPopover(e, row) 
                        }}>
                        <MoreVert />
                    </IconButton>
                </div>
            ),
            flex: .2
        }

    ], []);

    if (!employee) return null;


    return (
        <div >
             <Grid container justifyContent='space-between' 
             style={{ 
                marginBottom: '20px', 
                marginTop: '20px' 
                }}>

                <Grid item>
                    <Typography variant='h4' children={employee.name} />
                    <Typography variant='h5' children={employee.title.name} />
                </Grid>
            </Grid>
            <div className={classes.tableWrapper}>
        
                <DataGrid
                    className={classes.dataGrid}
                    columns={columns}
                    rows={(employee.evals || [])}
                    autoHeight
                    disableSelectionOnClick
                    hideFooterSelectedRowCount
                />
                <div>
                    <Menu
                        id='actions'
                        open={moreActions}
                        anchorEl={actions}
                        onClose={closePopover} 
                    >
                        <MenuItem onClick={() => {
                            history.push(`/employees/${employee_id}/evals/${rowSelected.id}`);
                        }}>
                            View Eval
                        </MenuItem>
                        {isAdmin && ( <MenuItem 
                        >
                            Delete
                        </MenuItem>)}
                    </Menu>
                </div>
            </div>
        </div>
    );
};

export default EmployeeEvalList;

